import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { TranslocoService } from '@ngneat/transloco';

import { Message } from '@core/interfaces';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  messageSource$ = new Subject<Message | Message[]>();
  clearSource$ = new Subject<string>();

  messageOpen$ = new Subject<Message>();
  messageClose$ = new Subject<Message>();

  remove$ = new Subject<string>();

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService) {}

  remove(id: string) {
    this.remove$.next(id);
  }

  info(message: Message) {
    this.add({
      ...message,
      key: 'main',
      severity: 'info',
      title: message.title ?? this.translate('core.components.toast.info'),
      duration: this.duration(message),
      sticky: message.sticky ?? false,
    });
  }

  success(message: Message) {
    this.add({
      ...message,
      key: 'main',
      severity: 'success',
      title: message.title ?? this.translate('core.components.toast.success'),
      duration: this.duration(message),
      sticky: message.sticky ?? false,
    });
  }

  warning(message: Message) {
    this.add({
      ...message,
      key: 'main',
      severity: 'warn',
      title: message.title ?? this.translate('core.components.toast.warning'),
      duration: this.duration(message),
      sticky: message.sticky ?? false,
    });
  }

  error(message: Message) {
    this.add({
      ...message,
      key: 'main',
      severity: 'error',
      title: message.title ?? this.translate('core.components.toast.error'),
      duration: this.duration(message),
      sticky: message.sticky ?? true,
    });
  }

  add(message: Message) {
    if (message) {
      this.messageSource$.next(message);
    }
  }

  clear(key?: string) {
    this.clearSource$.next(key || null);
  }

  duration(message: Message) {
    if (!message.duration) {
      return 5000;
    }

    if (message.duration < 1000) {
      return message.duration * 1000;
    } else {
      return message.duration;
    }
  }
}
